import { Component } from '@inter-ikea-core/core';

export enum Direction {
  UP,
  DOWN,
  LEFT,
  RIGHT
}

/**
 * Should be added to entities for which outer distance should be displayed.
 * Holds which directions the measurements should be displayed for.
 * Also holds directions that should not be displayed if the distance is to the room.
 * @param disabled - if the measurements should be displayed to the user or not
 */
export default class DistanceMeasurementComponent implements Component {
  static id = 2093;
  typeId = DistanceMeasurementComponent.id;
  directions: Direction[] = [];
  omitIfRoom: Direction[] = [];
  doStoreInSnapshot: boolean = true;
  serializable: boolean = false;
  measureCloserToWall?: boolean;
  disabled: boolean = false;

  constructor(
    directions: Direction[],
    omitIfRoom?: Direction[],
    measureCloserToWall?: boolean,
    disabled?: boolean
  ) {
    this.directions = directions;
    this.omitIfRoom = omitIfRoom || [];
    this.measureCloserToWall = measureCloserToWall;
    this.disabled = !!disabled;
  }

  eq() {
    return false;
  }
}
